import t from 'tcomb';
import Language from './Language';
import Country from './Country';

const Locale_Iso = t.subtype(t.Str, function(x) {
  var parts = x.split('_');
  return Language.is(parts[0]) && Country.is(parts[1]);
});

module.exports = Locale_Iso;


/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/domain/Locale_Iso.js
 **/